<template>
  <div>
    <div class="modal--createCertificate">
      <div class="modalCustom__header">
        <h5 class="">{{ data.header }}</h5>
        <div class="modalCustom__header-deleteButton">
          <p-button type="danger" icon outline @click.native.prevent="openDeleteModal()">
            <i class="fas fa-trash" />
          </p-button>
        </div>
        <hr class="modalCustom__header-border" />
      </div>

      <div class="modalCustom__body">
        <!-- Select Part -->
        <div class="row">
          <div class="w-full">
            <fg-input type="text" label="Name" placeholder="Certificate Name" v-model="name"> </fg-input>
          </div>
        </div>
        <div class="row">
          <label for="selected_provider" class="control-label">Provider</label>
          <multiselect
            v-model="selected_provider"
            :options="providers"
            @search-change="saveSearchValue($event)"
            id="selected_provider"
            :loading="loading"
            track-by="id"
            label="name"
            :searchable="true"
            :close-on-select="true"
            placeholder="Select Provider"
            :show-labels="true"
          >
            <template>
              <div slot="noResult" @click="createProvider(searchValue)">
                Create New Provider: <span class="text-primary"> {{ searchValue }} </span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="row">
          <label for="selected_question" class="control-label">Certificate Questions</label>
          <multiselect
            :options="questions"
            v-model="selected_questions"
            @select="selected_questions_ids.push({ question_id: $event.id })"
            @remove="removeOption($event)"
            id="selected_question"
            :loading="loadingQuestions"
            label="question_text"
            track-by="id"
            :searchable="true"
            :multiple="true"
            :close-on-select="false"
            placeholder="Select Questions"
            :show-labels="true"
          >
            <template slot="singleLabel" slot-scope="props">
              <div class="option">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.question_text }}</span>
                </div>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.question_text }}</span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="row">
          <div class="dashboard-element__icon-block">
            <fg-input
              type="file"
              :label="$t('Icon')"
              @fileAttached="attachFile($event)"
              :value="this.selected_certificate.img_url"
            ></fg-input>
          </div>
        </div>
        <!-- End Select Part -->
      </div>

      <div class="modalCustom__footer">
        <!--            buttons                   -->
        <div class="mr-3">
          <p-button type="danger" round @click.native.prevent="closeModal">
            {{ $t('Cancel') }}
          </p-button>
        </div>
        <div>
          <p-button type="success" round @click.native.prevent="editCertificate">
            {{ $t('update') }}
          </p-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProviderController from '../../controllers/Certificates/ProviderController';
import QuestionController from '../../controllers/Question/QuestionController';
import CertificateController from '../../controllers/Certificates/CertificateController';
import CertificateQuestionController from '../../controllers/Certificates/CertificateQuestionController';
import ModalTemplate from '../../components/modals/ModalTemplate';

export default {
  name: 'EditCertificateModal',
  components: { ModalTemplate },
  props: {
    data: {
      certificate: Object,
    },
  },
  data: function () {
    return {
      name: null,
      providers: [],
      selected_provider: null,
      selected_certificate: null,
      loading: false,
      searchValue: null,
      loadingQuestions: false,
      questions: [],
      selected_questions: [],
      selected_questions_ids: [],
      openDelete: false,
    };
  },
  async beforeMount() {
    this.loading = true;
    this.setCertificate();
    this.setProvider();
    this.setCertificateQuestions();
    await this.setProviders();
    await this.setQuestions();
    this.loading = false;
  },
  methods: {
    closeModal: function () {
      this.selected_provider = null;
      this.$emit('close');
    },
    editCertificate: async function () {
      try {
        let certificate = await this.updateCertificate();
        certificate = await this.updateCertificationQuestions(certificate);
        this.$notify({
          type: 'success',
          title: 'Certificate was updated',
        });
        this.$emit('submit', certificate);
        this.closeModal();
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
    async setProviders() {
      this.providers = await ProviderController.index();
    },
    async saveSearchValue(searchValue) {
      this.searchValue = searchValue;
    },
    async createProvider(providerName) {
      this.loading = true;

      try {
        let newProvider = await ProviderController.store({
          name: providerName,
        });
        this.$notify({
          type: 'success',
          title: 'Provider created',
        });
        this.providers.push(newProvider);
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.loading = false;
    },
    async setQuestions() {
      this.loadingQuestions = true;
      this.questions = await QuestionController.index();
      this.loadingQuestions = false;
    },
    async updateCertificate() {
      return await CertificateController.update(this.selected_certificate.id, {
        name: this.name,
        provider_id: this.selected_provider.id,
        img_url: this.selected_certificate.img_url,
      });
    },
    async updateCertificationQuestions(certificate) {
      return await CertificateQuestionController.store({
        certification_id: certificate.id,
        questions: this.selected_questions_ids,
      });
    },
    async removeOption(questionForRemove) {
      let foundIndex = this.selected_questions_ids.findIndex((question) => {
        return question.question_id === questionForRemove.id;
      });
      this.selected_questions_ids.splice(foundIndex, 1);
    },
    setCertificate() {
      this.selected_certificate = this.data.certificate;
      this.name = this.data.certificate.name;
    },
    setProvider() {
      this.selected_provider = this.data.certificate.provider;
    },
    setCertificateQuestions() {
      this.selected_questions = this.data.certificate.questions;
      this.selected_questions_ids = this.data.certificate.questions.map((question) => {
        return { question_id: question.id };
      });
    },
    openDeleteModal() {
      this.$emit('deleted');
      this.closeModal();
    },
    attachFile(img) {
      this.selected_certificate.img_url = img;
    },
  },
};
</script>

<style scoped></style>
